module.exports = __webpack_public_path__ + "media/images/hero-image-ouch-671ce337.svg";